import {formatPhoneNumber, isPossiblePhoneNumber} from 'react-phone-number-input';

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const convertToKebabCase = (str: string) => {
  return str.replace(/\s+/g, '-').toLowerCase();
};

export function toTitleCase(str: string) {
  return str
    .replace(/\w\S*/g,
      (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    )
    .replace(/And\s/, 'and ');
}

/**
 * Converts camelCase, PascalCase, snake_case, and kebab-case strings
 * into Title Case With Spaces (e.g., "orderStatusChanged" -> "Order Status Changed").
 * - Preserves acronyms already in all-caps (e.g., "API" remains "API").
 * - Collapses multiple delimiters and trims output.
 */
export function camelCaseToTitleCase(input: string): string {
  if (!input) return '';
  // Normalize delimiters to spaces
  let s = input
    .replace(/[_.\-]+/g, ' ')
    // Split camelCase/PascalCase boundaries: a lowercase/number followed by uppercase
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    // Split boundaries between consecutive capitals followed by a lowercase (HTMLParser -> HTML Parser)
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();

  // Title case words while preserving all-caps acronyms
  return s.split(' ').map((word) => {
    if (word.length > 1 && word === word.toUpperCase()) return word; // keep acronyms
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
}

// Backward-compatible alias (existing code may import this)
export function convertCamelCaseToTitleCase(str: string) {
  return camelCaseToTitleCase(str);
}

export function convertPascalToSentence(str: string) {
  return str.replace(/([A-Z])/g, ' $1');
}

export function stripPrefix(fieldName: string) {
  return fieldName.substring(fieldName.lastIndexOf('.') + 1);
}
export const removeSpecialCharacters = (str: string) => str.replace(/[^a-zA-Z ]/g, '').trim();

/**
 * Returns the number of occurrences in a string
 * @param {string} str The string to check
 * @param {string} countStr The string to check for
 * @returns {number} The number of occurrences
 */
export function countOccurrencesInString(str: string, countStr: string) {
  return (str.match(new RegExp(countStr, 'g')) || []).length;
}

export function convertToVariableName(str: string) {
  // remove all non-variable characters and replace them with underscores.
  str = str.replace(/[^a-zA-Z0-9 -]|\s+/g, '_')
    // replace multiple underscores next to each other with only one underscore
    .replace(/_+/g, '_')
    .replace(/-+/g, '_');
  // remove the last underscore if the string ends with it.
  if (str.length > 1 && str.lastIndexOf('_') === str.length - 1) {
    str = str.substr(0, str.length - 1);
  }
  return str;
}

export function isNullOrWhitespace(s: string | null | undefined) {
  return s === null || s === undefined || s.trim().length === 0;
}

export type Stringify<T> = { [K in keyof T]: string|undefined };

export function formatIfPossibleUsPhone(phoneNumber: string) {
  if (isPossiblePhoneNumber(phoneNumber, 'US')) return formatPhoneNumber(phoneNumber);
  else return phoneNumber;
}
